export enum ReAddSfiResponseStatus {
  Success,
  Failure,
  Skipped,
  Unknown,
}
